import { Component, computed, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { TagVariant } from './tag-variant.enum';

@Component({
  selector: 'ct-lib-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  standalone: true,
  imports: [FaIconComponent],
})
export class TagComponent {
  readonly variant = input<TagVariant>(TagVariant.DEFAULT);
  readonly deletable = input<boolean>(false);
  readonly accentColor = input<string | null>(null);
  readonly onDelete = output<void>();
  readonly faTimes = faTimes;
  readonly interactable = input<boolean>(false);
  readonly round = input<boolean>(false);
  readonly disabled = input<boolean>(false);

  variantClass = computed(() => {
    switch (this.variant()) {
      case TagVariant.COUNTER:
        return 'counter';
      case TagVariant.COUNTER_DEFAULT:
        return 'counter-default';
      case TagVariant.GREEN:
        return 'green';
      case TagVariant.YELLOW:
        return 'yellow';
      case TagVariant.RED:
        return 'red';
      case TagVariant.GRAY:
        return 'gray';
      case TagVariant.TRANSPARENT:
        return 'transparent';
      default:
        return '';
    }
  });
}
